import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { map, pipe, filter as filtr, addIndex, findIndex, slice, find } from 'ramda';
import YouTube from 'react-youtube';
import {
    Link,
    useLocation,
    useParams,
    useHistory,
} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectAllHorses } from '../reducers/horsesReducer';
import { selectSale } from '../reducers/salesReducer';
import Favorite from './Favorite';

const mapIndexed = addIndex(map);

function useQuery() {
    const query = new URLSearchParams(useLocation().search);
    return new URLSearchParams(useLocation().search);
}

const handleStateChange = (nextHorse, history) => ({data}) => {
    if (data === 0) {
        history.push(`?uts=true&horseId=${nextHorse.id}`);
    }
}

const onEnd = (event) => {
    event.target.seekTo(0);
    event.target.stopVideo();
}

const UTSVideo = ({horse, nextHorse, selected = false, pushLocation, autoplay=0, history}) => {
    const videoId = horse.video.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    return (
        <div
            className="embed-responsive embed-responsive-16by9"
            style={{
                clear: 'both',
            }}
        >
            <YouTube
                videoId={videoId[1]}
                opts={{
                    width: '100%',
                    playerVars: {
                        autoplay: 1,
                        rel: 0,
                        modestbranding: 1,
                    }
                }}
                className="embed-responsive-item"
                onStateChange={handleStateChange(nextHorse, history)}
                onEnd={onEnd}
            />
        </div>
    );
};

class UTSVideosView extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        galleryStartIndex: 0,
      };

      this.nextPage = this.nextPage.bind(this);
      this.previousPage = this.previousPage.bind(this);
    }

    previousPage() {
        const previousIndex = this.state.galleryStartIndex - 4;
        this.setState({
            galleryStartIndex: previousIndex > 0 ? previousIndex : 0,
        })
    }

    nextPage() {
        const { horses, consignorIDInt = null } = this.props;
        let horsesToUse = horses;
        if (consignorIDInt) {
            horsesToUse = filtr((h) => h.consignor_id == consignorIDInt)(horsesToUse);
        }
        const horsesWithVideos = filtr((horse) => !!horse.video, horsesToUse);
        const nextIndex = this.state.galleryStartIndex + 4;
        this.setState({
            galleryStartIndex: nextIndex < horsesWithVideos.length ? nextIndex : 0,
        })
    }


    componentWillReceiveProps(nextProps) {
        const { horses, horseId = null, consignorIDInt = null} = nextProps;
        let horsesToUse = horses;
        if (consignorIDInt) {
            horsesToUse = filtr((h) => h.consignor_id == consignorIDInt)(horsesToUse);
        }
        const horsesWithVideos = filtr((horse) => !!horse.video, horsesToUse);
        if (horsesWithVideos.length === 0) {
            return {
                galleryStartIndex: 0,
            };
        }
        const selectedHorseIndex = findIndex((horse) => horse.id == horseId, horsesWithVideos);
        const startingIndex = selectedHorseIndex > 0 ? Math.floor((selectedHorseIndex ) / 4) * 4 : 0;

        this.setState({
            galleryStartIndex: startingIndex,
        });
    }

    render() {
        let containerRef = null;
        const { horses, horseId, consignorIDInt = null, history, showFavorites = false } = this.props;
        let horsesToUse = horses;
        const consignorObj = find((c) => parseInt(c.consignor_id, 10) === consignorIDInt)(global.drupalSettings.catalogues.consignors_contacts);
        const main_color = consignorObj && consignorObj.main_color || global.drupalSettings.catalogues.main_color;
        const secondary_color = consignorObj && consignorObj.secondary_color || global.drupalSettings.catalogues.secondary_color;
        if (consignorIDInt) {
            horsesToUse = filtr((h) => h.consignor_id == consignorIDInt)(horsesToUse);
        }
        let horsesWithVideos = filtr((horse) => !!horse.video, horsesToUse);
        horsesWithVideos = showFavorites ? filtr(horse => horse.favorited)(horsesWithVideos) : horsesWithVideos;
        if (horsesWithVideos.length === 0) {
            return null;
        }
        let selectedHorseIndex = findIndex((horse) => horse.id == horseId, horsesWithVideos);
        selectedHorseIndex = selectedHorseIndex === -1 ? 0 : selectedHorseIndex;
        const selectedHorse = selectedHorseIndex !== -1 ? horsesWithVideos[selectedHorseIndex] : horsesWithVideos[0];
        const nextHorseIndex = selectedHorseIndex + 1;
        const previousHorseIndex = selectedHorseIndex - 1;
        const nextHorse = nextHorseIndex < horsesWithVideos.length ?
                horsesWithVideos[nextHorseIndex] : horsesWithVideos[0];
        const previousHorse = previousHorseIndex >= 0 ?
                horsesWithVideos[previousHorseIndex] : horsesWithVideos[horsesWithVideos.length - 1];
        const firstVideo = selectedHorse ? (
            <UTSVideo
                horse={selectedHorse}
                nextHorse={nextHorse}
                selected={true}
                autoplay={1}
                history={history}
            />
        ) : null;
        const videos = pipe(
            slice(this.state.galleryStartIndex, this.state.galleryStartIndex + 4),
            mapIndexed((horse, idx) => {
                const videoId = horse.video.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
                return (
                    <div className="col-sm-3 col-xs-6" key={idx}>
                        <Link to={`?uts=true&horseId=${horse.id}`}>
                            <img
                                className="img-fluid"
                                src={`https://img.youtube.com/vi/${videoId[1]}/hqdefault.jpg`}
                                alt={horse.hip}
                                style={{
                                    margin: '5px auto',
                                    cursor: 'pointer',
                                    outline: horse === selectedHorse ? `4px solid ${secondary_color}` : 'none',
                                }}
                            />
                        </Link>
                    </div>
                );
            })
        )(horsesWithVideos);

        return (
            <div
                className="uts-video-view"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 10000,
                    padding: 20,
                    overflowY: 'scroll',
                }}
                ref={(el) => containerRef = el}
            >
                <div
                    style={{
                        boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.5)',
                        backgroundColor: main_color,
                        maxWidth: 700,
                        margin: '0 auto',
                        marginTop: 60,
                    }}
                >
                    <div
                        className=""
                        style={{
                            backgroundColor: main_color,
                            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
                            marginBottom: 0,
                            minHeight: 50,
                            color: secondary_color,
                        }}
                    >
                        <div className=""
                            style={{
                                float: '',
                                padding: '15px',
                                textAlign: 'center',
                                width: '100%',
                            }}
                        >
                            <div className="float-left"
                                style={{
                                    color: '#fff',
                                    fontSize: '20px',
                                    padding: 0,
                                    // marginTop: -13,
                                }}
                            >
                                <Favorite horse={selectedHorse} color="#ffffff" />
                            </div>
                            <Link to={`?uts=true&horseId=${previousHorse.id}`} className="btn btn-link"
                                style={{
                                    color: secondary_color,
                                    fontSize: '20px',
                                    padding: 0,
                                    marginRight: 10,
                                }}
                            >
                                <FontAwesomeIcon style={{ color: '#ffffff', verticalAlign:"middle" }} icon={['fas', 'angle-left']} />
                            </Link>
                            <span style={{
                                fontWeight: 900
                            }}>
                                HIP {selectedHorse.hip}
                            </span>
                            <Link to={`?uts=true&horseId=${nextHorse.id}`} className="btn btn-link"
                                style={{
                                    color: secondary_color,
                                    fontSize: '20px',
                                    padding: 0,
                                    marginLeft: 10,
                                }}
                            >
                                <FontAwesomeIcon style={{ color: '#ffffff', verticalAlign:"middle" }} icon={['fas', 'angle-right']} />
                            </Link>
                            <div className="float-right">
                                <Link to="?" className="btn btn-link"
                                    style={{
                                        color: '#fff',
                                        fontSize: '20px',
                                        padding: 0,
                                        // marginTop: -18,
                                    }}
                                >
                                    <FontAwesomeIcon style={{ color: '#ffffff', verticalAlign:"middle" }} icon={['fas', 'times']} />
                                </Link>
                            </div>
                        </div>

                    </div>
                    {firstVideo}
                    <div
                        className={'row'}
                        style={{
                            padding: '5px 10px',
                            position: 'relative',
                        }}
                    >
                        {videos}
                        {
                            this.state.galleryStartIndex > 0 &&
                            <button className="btn btn-link"
                                style={{
                                    position: 'absolute',
                                    width: '30px',
                                    height: '30px',
                                    textAlign: 'center',
                                    padding: '5px 0',
                                    fontSize: '15px',
                                    lineHeight: 1.42,
                                    borderRadius: 15,
                                    backgroundColor: '#ced3e0',
                                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
                                    color: '#000',
                                    top: '40%',
                                    left: 30,
                                }}
                                onClick={this.previousPage}
                            >
                                <FontAwesomeIcon style={{ color: '#ffffff', verticalAlign:"middle" }} icon={['fas', 'angle-left']} />
                            </button>
                        }
                        {
                            this.state.galleryStartIndex + 4 < horsesWithVideos.length &&
                            <button className="btn btn-link"
                                style={{
                                    position: 'absolute',
                                    width: '30px',
                                    height: '30px',
                                    textAlign: 'center',
                                    padding: '5px 0',
                                    fontSize: '15px',
                                    lineHeight: 1.42,
                                    borderRadius: 15,
                                    backgroundColor: '#ced3e0',
                                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
                                    color: '#000',
                                    top: '40%',
                                    right: 30,
                                }}
                                onClick={this.nextPage}
                            >
                                <FontAwesomeIcon style={{ color: '#ffffff', verticalAlign:"middle" }} icon={['fas', 'angle-right']} />
                            </button>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapState = (state, props) => {
    return {
        horses: selectAllHorses(state),
        sale: selectSale(state),
    };
};

const mapDispatch = ((dispatch) => {
    return {
        pushLocation: location => dispatch(push(location)),
    };
});

const CVideosView = connect(mapState, mapDispatch)(UTSVideosView);


export default function VideoView () {
    const query = useQuery();
    const { consignorID = null, consignor=null } = useParams();
    const history = useHistory();
    const uts = query.get('uts') || false;
    const showFavorites = query.get('favorites') || false;
    if(!uts) {
        return null;
    }

    let consignorIDInt = consignorID ? parseInt(consignorID, 10) : null;
    consignorIDInt = consignor && consignor !== 'sale' ? parseInt(consignor) : consignorIDInt;

    return (
        <CVideosView
            showFavorites={showFavorites} 
            horseId={query.get('horseId') || null}
            consignorIDInt={consignorIDInt}
            history={history}
       />
    );
}